import { render } from "./CollectionCatalog.vue?vue&type=template&id=3236b78b&ts=true&lang=pug"
import script from "./CollectionCatalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCatalog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__